var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-bottom","mode":"out-in"}},[_c('div',{staticClass:"fixed left-0 right-0 top-0 bottom-0 reverse flex align-items-center justify-content-center reverse"},[_c('svg-loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }